var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.hasContent)?_c('div',{staticClass:"fixed bottom-0 z-1000 w-full md:hidden"},[_c(_vm.barComponent,{tag:"component"}),_c('MountingPortal',{attrs:{"mountTo":"body","append":""}},[_c('div',{staticClass:"h-20 md:hidden"})])],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }